import React from 'react';

import { Swiper, SwiperSlide } from 'swiper/react';
import { HeaderFilterContainer } from './style';

import { FilterTag, LoadingShimmer } from '@icarros/ids-react';
import { useFilter } from '../../store/hooks/useFilter';
import { pushSellerPFDashboardEvent } from '../../../utils/pushToDataLayer';
import { useListingFilterContext } from '../../store/contexts/listingFilter';

import 'swiper/swiper.min.css';
import { STATUS } from '../../enum/listing-status';

interface HeaderFilterProps {
  isShimmering: boolean;
}

export function HeaderFilter({ isShimmering }: Readonly<HeaderFilterProps>): JSX.Element {
  const { selectedOption, setSelectedOption } = useListingFilterContext();
  const { filterOptions } = useFilter();

  function handleChange(name: keyof typeof STATUS, text: string) {
    pushSellerPFDashboardEvent(text);

    setSelectedOption(name);
  }

  return (
    <HeaderFilterContainer>
      <Swiper spaceBetween={16} slidesPerView="auto">
        {filterOptions?.map(({ name, text, value }) => (
          <SwiperSlide key={name}>
            <LoadingShimmer show={isShimmering} height="34px" width="200px">
              <FilterTag
                checked={selectedOption === name}
                name={name}
                text={text}
                badgeValue={value === 0 ? '' : String(value)}
                onChange={(checked, name) => {
                  const typedName = name as keyof typeof STATUS;
                  handleChange(typedName, text);
                }}
                isDisabled={value === 0}
              />
            </LoadingShimmer>
          </SwiperSlide>
        ))}
      </Swiper>
    </HeaderFilterContainer>
  );
}
